import React, { useEffect } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import defaultImage from '../images/LogoDoang.svg';
import I1 from '../images/project/oskmitb.jpg';
import I2 from '../images/project/byte.png';
import I3 from '../images/project/Home.png';
import I4 from '../images/project/Algeo-1.png';
import I5 from '../images/logo/HTML.svg';
import I6 from '../images/project/burbir.png';
import I7 from '../images/project/RoadEye.png';
import I8 from '../images/project/dicedu.png';
import I9 from '../images/project/daspro.png';
import I10 from '../images/project/Cyberpunk.png';
import I11 from '../images/project/TUCIL2STIMA.png';
import I12 from '../images/project/SeaSalon.png';
import I13 from '../images/project/Nelfix.png';
import I14 from '../images/project/AlkitabFinder.png';
import I15 from '../images/project/WikiRace.png';
import l1 from '../images/logo/c.svg'
import l2 from '../images/logo/java.svg'
import l3 from '../images/logo/python.svg'
import l4 from '../images/logo/ts.svg'
import l5 from '../images/logo/tailwind.svg'
import l6 from '../images/logo/react.svg'
import l7 from '../images/logo/prisma.svg'
import l8 from '../images/logo/next-js.svg'
import l9 from '../images/logo/gdsc-logo.svg'
import l10 from '../images/logo/postgresql.svg'
import l11 from '../images/logo/fastapi.svg'
import l12 from '../images/logo/csharp.svg'
import l13 from '../images/logo/go.svg'
import l14 from '../images/logo/cpp.svg'
import l15 from '../images/logo/r2.svg'
import Play from '../images/Play.svg';
import link from '../images/link.svg';
import Pause from '../images/Pause.svg';
import Reveal from './Reveal';
import ProjectCard from './ProjectCard';

const Project = () => {
    const HandlerDirect = () => {

        const active = document.querySelector('li.is-active>div>h2').textContent;
        const index = listimage.findIndex((item) => item.title === active);
        const link = listimage[index].link;
        window.open(link, "_blank");
    }

    const listimage = [
        {
            src: I1,
            alt: 'Image 1',
            title: "Backend Engineer OSKM ITB 2023",
            link: "#Project",
            info: [
                {
                    img: l8,
                    alt: 'Next.js',
                },
                {
                    img: l7,
                    alt: 'Prisma',
                },
                {
                    img: l10,
                    alt: 'PostgreSQL',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
            ]
        },
        {
            src: I2,
            alt: 'Image 2',
            title: "IT Byte ITB 2022",
            link: "https://byte22.steikitb.site/",
            info: [
                {
                    img: l6,
                    alt: 'React.js',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
            ]
        },
        {
            src: I3,
            alt: 'CBIR',
            title: "Content Based Image Retrieval Web App",
            link: "https://github.com/ValentinoTriadi/Algeo02-22134/",
            info: [
                {
                    img: l8,
                    alt: 'Next.js',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
                {
                    img: l3,
                    alt: 'Python',
                },
                {
                    img: l11,
                    alt: 'FastAPI',
                },
            ]
        },
        {
            src: I4,
            alt: 'Matrix Calculator',
            title: "Matriks Calculator Web App",
            link: "https://github.com/ValentinoTriadi/Algeo01-22153/",
            info: [
                {
                    img: l2,
                    alt: 'Java',
                },
            ]
        },
        {
            src: I5,
            alt: 'HTML Parser PDA',
            title: "HTML Parser PDA",
            link:"https://github.com/ValentinoTriadi/HTML-Parser-PDA_Bukan-Besok-Minggu",
            info: [
                {
                    img: l3,
                    alt: 'Python',
                },
            ]
        },
        {
            src: I6,
            alt: 'X Clone',
            title: "X Clone CLI App",
            link:"https://github.com/ValentinoTriadi/TugasBesar_IF2110_2023_A",
            info: [
                {
                    img: l1,
                    alt: 'C',
                },
            ]
        },
        {
            src: I7,
            alt: 'GDSC Hackfest 2024',
            title: "RoadEye (Traffic Analyst Web App)",
            link:"https://github.com/ValentinoTriadi/RoadEye",
            info: [
                {
                    img: l8,
                    alt: 'Next.js',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
                {
                    img: l9,
                    alt: 'Top 20 GDSC Hackfest 2024',
                },
                {
                    img: l3,
                    alt: 'Python',
                },
                {
                    img: l11,
                    alt: 'FastAPI',
                },
            ]
        },
        {
            src: I8,
            alt: 'Dicedu',
            title: "Dicedu (Education Game)",
            link:"https://github.com/ValentinoTriadi/Dicedu---Tubes-Pengkom-2022",
            info: [
                {
                    img: l3,
                    alt: 'Python',
                },
            ]
        },
        {
            src: I9,
            alt: 'Tubes Daspro',
            title: "Candi Manajerial App",
            link:"https://github.com/ValentinoTriadi/Bondowoso---Tubes-Daspro-2023",
            info: [
                {
                    img: l3,
                    alt: 'Python',
                },
            ]
        },
        {
            src: I10,
            alt: 'Tucil 1 Stima',
            title: "Cyberpunk 2077 Breach Protocol Solver",
            link:"https://github.com/ValentinoTriadi/Tucil1_13522164",
            info: [
                {
                    img: l3,
                    alt: 'Python',
                },
            ]
        },
        {
            src: I11,
            alt: 'Tucil 2 Stima',
            title: "Bezier Curve Website",
            link:"https://github.com/ValentinoTriadi/Tucil2_13522161_13522164",
            info: [
                {
                    img: l8,
                    alt: 'Next JS',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
            ]
        },
        {
            src: I12,
            alt: 'Sea Salon',
            title: "Sea Salon - Salon Management Web App",
            link:"https://github.com/ValentinoTriadi/SEA-Salon",
            info: [
                {
                    img: l8,
                    alt: 'Next JS',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
                {
                    img: "https://user-images.githubusercontent.com/7461010/229049976-db6b9733-0215-437e-9922-41c2da34e18d.svg",
                    alt: 'Next Auth',
                },
                {
                    img: l7,
                    alt: 'Prisma',
                },
                {
                    img: l10,
                    alt: 'PostgreSQL',
                },
            ]
        },
        {
            src: I13,
            alt: 'Nelfix',
            title: "Nelfix - Netflix Clone Web App",
            link:"https://github.com/ValentinoTriadi/Labpro-Seleksi-3-NestJS",
            info: [
                {
                    img: "https://upload.wikimedia.org/wikipedia/commons/a/a8/NestJS.svg",
                    alt: 'Nest JS',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
                {
                    img: l7,
                    alt: 'Prisma',
                },
                {
                    img: l10,
                    alt: 'PostgreSQL',
                },
                {
                    img: l15,
                    alt: 'Cloudfare R2 Buckets',
                },
            ]
        },
        {
            src: "https://raw.githubusercontent.com/ValentinoTriadi/Tubes2_OOP/main/img/logo.png",
            alt: 'Tubes 1 OOP',
            title: "Town Game CLI App",
            link:"https://github.com/ValentinoTriadi/Tubes1_OOP",
            info: [
                {
                    img: l14,
                    alt: "C++",
                },
            ]
        },
        {
            src: "https://raw.githubusercontent.com/ValentinoTriadi/Tubes2_OOP/main/img/logo.png",
            alt: 'Tubes 2 OOP',
            title: "Farm Game Dekstop App",
            link:"https://github.com/ValentinoTriadi/Tubes2_OOP",
            info: [
                {
                    img: l2,
                    alt: 'Java',
                },
            ]
        },
        {
            src: I15,
            alt: 'Tubes 2 Stima',
            title: "WikiRace Solver Web App",
            link:"https://github.com/ValentinoTriadi/Tubes2_GasAja",
            info: [
                {
                    img: l13,
                    alt:'Go',
                },
                {
                    img: l8,
                    alt: 'Next JS',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
            ]
        },
        {
            src: defaultImage,
            alt: 'Tucil 3 Stima',
            title: "Word Ladder Solver Dekstop App",
            link:"https://github.com/ValentinoTriadi/Tucil3_13522164",
            info: [
                {
                    img: l2,
                    alt: 'Java',
                },
            ]
        },
        {
            src: "https://raw.githubusercontent.com/ValentinoTriadi/Tubes3_BesokMinggu/main/src/Tubes3_BesokMinggu/Screenshots/messageImage_1717949743365.jpg",
            alt: 'Tubes 3 Stima',
            title: "Fingerprint Scanner Dekstop App",
            link:"https://github.com/ValentinoTriadi/Tubes3_BesokMinggu",
            info: [
                {
                    img: l12,
                    alt:'C#',
                }   
            ]
        },
        {
            src: I14,
            alt: 'Makalah Stima',
            title: "Alkitab Finder",
            link:"https://github.com/ValentinoTriadi/Alkitab-Finder",
            info: [
                {
                    img: l8,
                    alt: 'Next JS',
                },
                {
                    img: l4,
                    alt: 'TypeScript',
                },
                {
                    img: l5,
                    alt: 'Tailwind CSS',
                },
                {
                    img: l3,
                    alt: 'Python',
                },
                {
                    img: l11,
                    alt: 'FastAPI',
                },
            ]
        },
    ]
    const option = {
        type         : 'loop',
        gap          : '1rem',
        autoplay     : true,
        pauseOnHover : false,
        resetProgress: false,
        perPage: 1,
    };

    return (
        <section className="w-full flex justify-center item-center flex-col h-fit min-h-screen" id="Project">
            <h2 className='py-10 text-white text-7xl font-bold font-poppins text-center'>Project</h2>
            <Reveal classname="w-full">
                <div className='w-full flex justify-center item-center bg-gray-400 rounded-[30px] bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-20 border border-gray-100 neumorphism'>
                    <div className='w-[90%] m-10'>
                        <Splide
                        options={ option }
                        hasTrack={ false }
                        className='flex justify-center items-center flex-col '
                        on
                        >

                            <div className='w-full relative rounded-t-[15px]'>
                                <SplideTrack>
                                { listimage.map( slide => (
                                    <SplideSlide key={ slide.src } className='flex justify-center items-center'>
                                        <ProjectCard {...slide} />
                                    </SplideSlide>
                                ) ) }
                                </SplideTrack>
                            </div>
                    
                            <div className="splide__progress w-full">
                                <div className="splide__progress__bar" />
                            </div>
                            
                            <div>
                                <button className="splide__toggle text-white pt-10 px-1">
                                    <span className="splide__toggle__play opacity-30 hover:opacity-100"><img src={Play} width={40} title="Play"/></span>
                                    <span className="splide__toggle__pause opacity-30 hover:opacity-100"><img src={Pause} width={40} title="Pause"/></span>
                                </button>
                                <button className='px-1' title="Project Direct Link" onClick={HandlerDirect}>
                                    <span className="opacity-30 hover:opacity-100"><img src={link} width={40} alt="Play"/></span> 
                                </button>
                            </div>
                        </Splide>
                    </div>
                </div>
            </Reveal>
        </section>
    );
};

export default Project;
